// 必填校验规则
export const makeRequiredRule = (message = '必填') => {
    return { required: true, message, trigger: ['change', 'blur'] };
};

// 创建自定义校验规则
export const makeValidatorRule = function (validatorFn) {
    return { validator: validatorFn, trigger: ['change', 'blur'] };
};
